// extracted by mini-css-extract-plugin
export default {"FormError":"qKDew9PR"};